import { BaseDto } from "../base/baseDto.model"

export class ParametroSistemaDto extends BaseDto{
  public nombre: string= ""
  public valor: string= ""
  public descripcion: string= ""
}
